/**
 * Player position enum
 */
export enum Position {
  Goalkeeper = 'GOALKEEPER',
  Defender = 'DEFENDER',
  Midfielder = 'MIDFIELDER',
  Forward = 'FORWARD',
}
